// web/src/copilot/AskAboutButton.tsx
//
// Sparkle affordance rendered next to <NotesBadge> on cluster + analysis
// cards. Clicking it:
//   1. stops propagation so the host card doesn't toggle / collapse, and
//   2. writes the click target into PendingContext, and
//   3. dispatches a window event so AskTapelensButton's local sheet state
//      can flip open without prop drilling.
//
// The chat sheet picks up `pending` on its next open cycle and pre-injects
// it into the agent's context as a one-shot CopilotKit readable.
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  usePendingContext,
  type PendingContextValue,
} from "./PendingContextProvider";

export const ASK_TAPELENS_OPEN_EVENT = "ask-tapelens:open";

export function AskAboutButton({ target }: { target: PendingContextValue }) {
  const { setPending } = usePendingContext();
  const { t } = useTranslation("copilot");
  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-6 w-6 text-muted-foreground hover:text-foreground"
      aria-label={t("askAbout.ariaLabel")}
      onClick={(e) => {
        e.stopPropagation();
        setPending(target);
        window.dispatchEvent(new CustomEvent(ASK_TAPELENS_OPEN_EVENT));
      }}
    >
      <Sparkles className="h-3 w-3" />
    </Button>
  );
}
